import React, { useCallback } from "react";
import { IItemContentProps } from "../../../Orchestrator/Types/Index";

const ItemContent: React.FC<IItemContentProps> = React.memo(
  ({
    type,
    currentCount,
    handlePassengerChange,
    isDecrementDisabled,
    isIncrementDisabled,
    searchPassengers,
  }) => {
    const { id, description, label } = type;

    const decrement = useCallback(async () => {
      await handlePassengerChange(id, -1);

      if (id !== "infants" && searchPassengers) {
        const currentInfantCount = searchPassengers["infants"] || 0;
        const updatedNonInfantCount =
          Object.entries(searchPassengers)
            .filter(
              ([passengerType]) =>
                passengerType !== "infants" && passengerType !== id
            )
            .reduce((sum, [, count]) => sum + (count as number), 0) +
          (searchPassengers[id] - 1);

        if (currentInfantCount > updatedNonInfantCount) {
          //await handlePassengerChange("infants", -1);
        }

        if (updatedNonInfantCount <= 0 && currentInfantCount > 0) {
          //await handlePassengerChange("infants", -currentInfantCount);
        }
      }
    }, [id, searchPassengers, handlePassengerChange]);

    const increment = useCallback(
      () => handlePassengerChange(id, 1),
      [id, handlePassengerChange]
    );

    return (
      <div className="passenger-item">
        <div className="item-content">
          <div className="labels">
            <h4>{label}</h4>{/* Bold Text */}
            <span className="passenger-description">{description}</span>
            {/* {additionalInfo && (
              <span className="additional-info">
                {intl.formatMessage(
                  { id: `${labelId}AdditionalInfo` },
                  { defaultMessage: additionalInfo }
                )}
              </span>
            )} */}
          </div>
          <div className="selector">
            <button
              name="decrement"
              onClick={decrement}
              disabled={isDecrementDisabled}
              aria-label={"decrementPassengers"}
              className={isDecrementDisabled ? "disabled" : ""}
            >
              -
            </button>
            <span>{currentCount}</span>
            <button
              name="increment"
              onClick={increment}
              disabled={isIncrementDisabled}
              aria-label={"incrementPassengers"}
              className={isIncrementDisabled ? "disabled" : ""}
            >
              +
            </button>
          </div>
        </div>
      </div>
    );
  }
);

// Set the display name for the memoized component
ItemContent.displayName = "ItemContent";

export default ItemContent;
